import axios from "axios";
import config from "./config";

// Mirrors the FROZEN response shape documented in yuso-portals-backend
// src/handlers/myServices/commoditySignTokenHandler.ts — do not reshape here.

export type CommodityDirection = "injection" | "offtake" | "combined";

export interface CommodityInjectionFees {
  platform_fee: number | null;
  min_platform_fee: number | null;
  imbalance_cost_pct: number | null;
}

export interface CommodityOfftakeFees {
  platform_fee: number | null;
  min_platform_fee: number | null;
  price_gsc: number | null;
  price_wkc: number | null;
}

export interface CommoditySignBillingInfo {
  billingEmail: string;
  iban: string;
  billingAddressStreet: string;
  billingAddressNumber: string;
  billingAddressZip: string;
  billingAddressCity: string;
  billingAddressCountry: string;
}

export interface CommoditySignTokenData {
  contract: {
    ean: string;
    direction: CommodityDirection;
    company_name: string;
    start_date: string | null;
    effective_start_date: string | null;
    end_date: string | null;
    fees: {
      injection: CommodityInjectionFees | null;
      offtake: CommodityOfftakeFees | null;
    };
    product: string | null;
  };
  pdf_urls: { injection: string | null; offtake: string | null };
  billing_info: CommoditySignBillingInfo;
  company_email: string;
  can_sign: boolean;
  sign_blocked_reason: string | null;
}

export interface CommoditySignPayload {
  name: string;
  signee_function?: string;
  signature_image?: string | null;
  billingInfo: CommoditySignBillingInfo;
  companyEmail: string;
}

export async function fetchCommodityContractByToken(token: string): Promise<CommoditySignTokenData> {
  const { data } = await axios.get<CommoditySignTokenData>(
    `${config.API_SERVICES}/api/v1/contracts/sign-token/${token}`,
  );
  return data;
}

export async function signCommodityContractByToken(
  token: string,
  payload: CommoditySignPayload,
): Promise<void> {
  await axios.post(`${config.API_SERVICES}/api/v1/contracts/sign-token/${token}`, payload);
}
